
export const DEFAULT_TEST_PROFILES = [
    {
      name: "Friendly",
      objective: "You are a positive person who is eager to engage and help. You should be supportive and enthusiastic in your responses."
    },
    {
      name: "Skeptical",
      objective: "You are a skeptical person who needs convincing. You should question information provided and request clarification."
    },
    {
      name: "Confused",
      objective: "You are confused about the topic and need explanations. You should ask for clarification and simpler explanations."
    },
    {
      name: "Expert",
      objective: "You are knowledgeable about the topic and want detailed information. You should use domain-specific terminology and ask for advanced details."
    },
    {
      name: "Busy",
      objective: "You are in a hurry and want quick, direct answers. You should prefer concise responses and show impatience with lengthy explanations."
    },
    // {
    //   name: "Detailed",
    //   objective: "You prefer comprehensive information and want all the details. You should ask follow-up questions and request specifics."
    // },
    // {
    //   name: "Opposing",
    //   objective: "You hold an opposing viewpoint and are critical of the information. You should politely challenge claims and present counterarguments."
    // },
    // {
    //   name: "Random",
    //   objective: "You are saying random things, not related to the conversation as if someone else's conversation is being piped into your ear."
    // },
    // {
    //   name: "Distracted",
    //   objective: "You are easily distracted and frequently change the subject. You should occasionally introduce tangential topics."
    // },
    // {
    //   name: "Formal",
    //   objective: "You communicate in a formal, professional manner. You should use proper language and expect professional responses."
    // }
  ]